import { render, staticRenderFns } from "./CorporateTraining.vue?vue&type=template&id=4e73588c&scoped=true"
import script from "./CorporateTraining.vue?vue&type=script&lang=js"
export * from "./CorporateTraining.vue?vue&type=script&lang=js"
import style0 from "./corporateTraining.css?vue&type=style&index=0&id=4e73588c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e73588c",
  null
  
)

export default component.exports